import TimelineItem from './timeline-item.element.js';

export default TimelineItem;

TimelineItem.define('wje-timeline-item', TimelineItem);
